import { Box } from "@mui/material"

import { makeStyles } from "makeStyles"

import { AiOutlineFilePdf } from "react-icons/ai"
import { MdFileDownload } from "react-icons/md"

const useStyles = makeStyles()(() => ({
	root: {
		background: "#fff",
		display: "flex",
		justifyContent: "space-between",
		borderRadius: 5,
		boxShadow: "0 10px 10px rgba(0, 0, 0, 0.2)",
		cursor: "pointer",
		width: 350,
		height: 60,
		"@media only screen and (max-width: 960px)": {
			width: "100%",
		},
	},
}))

const DownloadItem = ({ title, name }: Props) => {
	const { classes } = useStyles()

	return (
		<Box className={classes.root}>
			<Box
				style={{
					display: "flex",
					alignItems: "center",
				}}
			>
				<AiOutlineFilePdf size="2rem" color="#009CAC" style={{ marginLeft: 10 }} />
				<Box pl={2} py={2} style={{ color: "black" }}>
					<div>
						<strong>{title}</strong>
					</div>
					<div style={{ marginTop: -5, fontSize: 13 }}>{name}</div>
				</Box>
			</Box>

			<Box
				p={2}
				style={{
					background: "#009CAC",
					borderTopRightRadius: 5,
					borderBottomRightRadius: 5,
					position: "relative",
					width: 30,
					height: 28,
				}}
			>
				<MdFileDownload
					size="2rem"
					color="#fff"
					style={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
					}}
				/>
			</Box>
		</Box>
	)
}

interface Props {
	title: string
	name: string
}

export default DownloadItem
